import { Component, ViewChild } from '@angular/core';
import { ModalController, NavController, NavParams } from 'ionic-angular';
import { AngularFireDatabase } from 'angularfire2/database';
import { CustomepopupComponent } from "../../components/customepopup/customepopup";
import { SmartanimationProvider } from "../../providers/smartanimation/smartanimation";
@Component({
  selector: 'page-customer-servers',
  templateUrl: 'customer-servers.html',
})
export class CustomerServersPage {
  @ViewChild('divAnimate') divAnimate;
  restKey: string;
  listServers: any = [];
  isLoading: boolean = true;
  path: string;
  tableId: string;
  constructor(

    // Services
    public navCtrl: NavController,
    public navParams: NavParams,
    public af: AngularFireDatabase,
    public openModel: ModalController,
    public animateService: SmartanimationProvider
  ) {
    // Constructor Function
    console.log('Animation Loading');
    this.restKey = this.navParams.get('resId');
    this.path = 'restaurants/' + this.restKey + '/servers';
    this.isLoading = true;
    this.af.list(this.path, ref => {
      let obj = ref.orderByChild('isAvailable').equalTo(true);
      return obj;
    }).valueChanges().subscribe((res) => {
      this.listServers = res;
      this.isLoading = false;
    });
  }

  ionViewWillEnter() {
    this.animateService.smartAnimation().setType('fadeIn').show(this.divAnimate.nativeElement);
  }

  alertModel(server) {
    console.log(server);
    let alertModal = this.openModel.create(CustomepopupComponent, { server: server, tableId: this.tableId,resturenData:this.navParams.get('resturenData') });
    alertModal.present();
  }
  connect() {
    this.navCtrl.pop();
  }
}



// WEBPACK FOOTER //
// ./src/pages/customer-servers/customer-servers.ts